module.exports = __webpack_public_path__ + "assets/img/recommend_icon04.9efe3c8b.png";